import { Drawing } from "./Drawing";
import { DrawingsCollection } from "./DrawingsCollection";
import { State } from "../redux/State";
import { Map } from "immutable";
import { Keys } from "../redux/Datastore";
import {get_a_drawing, get_default_drawing} from "../DrawingHistory";
import { exists } from "../utils";
import { Id_drawing } from "../api/Identifiers";

export function temp_action_set_floorplan_data(state: Map<any, any>, data: any): Map<any, any> {
    let old_state: State = State.wrap(state);
    return DrawingsReducer.Action_set_floorplan_data(old_state, data).toImmutable();
}


export class DrawingsReducer {
    public static ACTION_SET_FLOORPLAN_DATA = "ACTION_SET_FLOORPLAN_DATA";

    public static Action_set_floorplan_data(old_state: State, data: any): State {
        let state: State = old_state;
        let new_drawings: DrawingsCollection = DrawingsCollection.build_from_raw(data);
        let drawings: DrawingsCollection = old_state.all_drawings;
        drawings.add_collection(new_drawings);
        state = state.set_drawings_data(drawings);
        // build up a mapping of default drawings for each floor
        let drawing_location_map: any = drawings.drawing_location_map;
        state = state.set_obj(Keys.KEY_DATA_DRAWING_LOCATION_MAP, drawing_location_map);

        // If a drawing is already actively selected and it's still present in the
        // just-merged collection, leave it alone - a background floorplan-data update
        // (e.g. for a different floor/building still loading) should never silently
        // override what the user is currently looking at.
        let current_id_drawing: Id_drawing = old_state.id_drawing;
        if (exists(current_id_drawing) && exists(drawings.displayable_drawings.get_drawing_from_drawing_id(current_id_drawing))) {
            return state;
        }

        let a_drawing: Drawing = null;

        a_drawing = get_a_drawing(state);
        if (!exists(a_drawing)){
            a_drawing = get_default_drawing(state);
        }

        if (exists(a_drawing)) {
            // we found a floor. set up the state to point to that floor
            state = state.set_drawing(a_drawing);
        }

        return state;
    }
}